<template>
  <section
    class="default-navbar"
    id="top-navbar-view"
    :class="{
      beforeScroll: scrollPosition < 0,
      afterScroll: scrollPosition > 0.5,
    }"
  >
    <el-row type="flex" align="middle">
      <el-col :lg="6" :xl="7">
        <ul class="navbar-logo-grid">
          <li>
            <div class="logo">
              <router-link to="/all-cases">
                <img
src="@/assets/images/labSquire-logo.svg"
                  alt="testgo-tri-logo"
                  style="height: 60px;"
                  class="img-fluid"
                />
              </router-link>
            </div>
          </li>
          <li class="pl-20">
            <div class="menu-toggle-button cursor">
              <span class="el-dropdown-link" @click="menuNavigation = true">
                <img
                  src="../assets/images/dashboard-icon.svg"
                  alt="dashboard-icon"
                />
              </span>
            </div>
          </li>
          <li>
            <div class="title">
              <Title></Title>
            </div>
          </li>
        </ul>
      </el-col>
      <el-col :lg="14" :xl="11">
        <div class="navbar-filters">
          <div class="quick-navigation">
            <ul>
              <li
                v-if="
                  globalRouteNames.indexOf($route.name) == -1 &&
                  hasPermission('case_reports', 'view')
                "
              >
                <router-link to="/global-search" class="bg-blue">
                  <span class="global-search-d-flex">
                    <span class="mr-8">Global</span>
                    <span>
                      <img
                        class="inactive"
                        src="../assets/images/icons/global-search-icon-new.svg"
                        alt="icon"
                      />
                    </span>
                  </span>
                </router-link>
              </li>
              <li>
                <router-link
                  to="/all-cases"
                  :class="{
                    active: isRouteActive([
                      'AllCases',
                      'ActiveCases',
                      'SamplesReceived',
                      'PendingCases',
                      'CompleteCases',
                      'ArchiveCase',
                      'CaseView',
                      'Case-Information-Update',
                      'NewCase',
                      'EMRNotSend',
                      'ReleasePending',
                      'RejectedCases',
                      'ReplacedInsurance',
                      'RequiresAttentionCases',
                      'FaxNotSentCases',
                      'FaxInProcessCases',
                      'TatCrossedCases',
                      'PriorityCases',
                      'InsuranceExceptionCases'
                    ]),
                  }"
                  >All Cases</router-link
                >
              </li>
              <li v-if="hasPermission('orders', 'view') && !isAPEXLab">
                <router-link
                  to="/all-orders/active"
                  :class="{
                    active: isRouteActive([
                      'AllOrders',
                      'ActiveOrders',
                      'CompleteOrders',
                      'ArchiveOrders',
                      'Order-Information',
                      'Edit-Order-Info',
                      'NewOrder',
                      'PartialOrders',
                      'RejectionOrders',
                      'PendingOrders',
                      'RequiresAttentionOrders',
                      'CollectedSamplesOrders',
                      'SampleAckOrders',
                      'PartiallyRejectedOrders',
                    ]),
                  }"
                  >TestGo Orders</router-link
                >
              </li>
              <li v-if="hasPermission('global_search', 'view')">
                <router-link
                  to="/all-send-outs"
                  :class="{
                    active: isRouteActive([
                      'allSendOuts',
                      'ActiveSendOuts',
                      'CompleteSendOuts',
                      'SendOutsEdit',
                      'SendoutsInformation',
                      'SendOutsView',
                      'ArchiveSendouts',
                    ]),
                  }"
                  >Sendouts</router-link
                >
              </li>
              <li v-if="hasPermission('billing', 'view')">
                <router-link
                  to="/all-billing-cases/pending"
                  :class="{
                    active: isRouteActive([
                      'AllPendingBilledCases',
                      'BilledCases',
                      'ClientBilledCases',
                      'ExceptionBilledCases',
                      'OnholdBilledCases',
                      'BilledExceptionBilledCases',
                      'BilledPatientBilledCases',
                      'CodingCases',
                      'ExceptionResolvedCases',
                      'ExceptionReviewedCases',
                    ]),
                  }"
                  >Billing</router-link
                >
              </li>
              <li v-if="isLabAbleToViewInventory && !isAPEXLab">
                <a @click="gotoInventory()" style="cursor: pointer;">Inventory</a>
              </li>
              <!-- <li v-if="isSuperAdmin">
                <router-link to="/logs/system-logs" :class="{ active: isRouteActive(['systemLogs']) }">System Logs</router-link>
              </li> -->
              <li v-if="ableToReleaseReport && !isAPEXLab">
                <router-link to="/instrument-queue" :class="{ active: isRouteActive(['InstrumentQueue']) }">LAB CONSOLE</router-link>
              </li>
            </ul>
          </div>
          <div>
            <navFilters></navFilters>
          </div>
        </div>
      </el-col>
      <el-col :lg="4" :xl="6">
        <div
          class="location_grid"
          v-if="hasPermission('cases', 'new_location') && !isGowthamUser"
        >
          <div class="new-case-button">
            <el-select
              v-model="selectedLab"
              placeholder="Select Lab"
              @change="setSelectedLab"
            >
              <el-option
                v-for="(lab, index) in this.getUserAllowedLabs"
                :key="index"
                :label="lab.name"
                :value="lab._id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <ul class="navbar-action-grid">
          <!-- <li
            style="text-align: start"
            v-if="
              casesRouteNames.indexOf($route.name) != -1 &&
              hasPermission('cases', 'create_case_new')
            "
          >
            <div class="new-case-button">
              <el-button @click="goToNewCase" class="nav-btn">
                <span class="plus-icon"
                  ><img
                    src="../assets/images/icons/plus-icon.svg"
                    alt="" /></span
                >NEW CASE
              </el-button>
            </div>
          </li>
          <li
            v-if="
              casesRouteNames.indexOf($route.name) != -1 &&
              hasPermission('orders', 'create')
            "
          >
            <div class="new-case-button">
              <el-button @click="addNewOrder" class="nav-btn">
                <span class="plus-icon"
                  ><img
                    src="../assets/images/icons/plus-icon.svg"
                    alt="" /></span
                >ADD NEW ORDER
              </el-button>
            </div>
          </li> -->

          <li
            v-if="
              casesRouteNames.indexOf($route.name) == -1 &&
              globalRouteNames.indexOf($route.name) == -1
            "
          >
            <div class="navbar-back-navigation" v-if="!$route.query.expire">
              <GoBackButton></GoBackButton>
            </div>
          </li>
          <!-- View / edit pages (a case, order or sendout) have a Back button here
               and no room for these two, so they are left out. -->
          <li v-if="!isDetailRoute">
            <KeyboardShortcuts></KeyboardShortcuts>
          </li>
          <li v-if="!isDetailRoute">
            <div class="notification-block">
              <el-badge :value="total" class="item" :loading="countsLoading">
                <el-dropdown
                  @command="handleCommand"
                  class="notification-dropdown"
                >
                  <el-button>
                    <img
                      src="../assets/images/icons/active.svg"
                      width="30"
                      height="30"
                    />
                  </el-button>
                  <template #dropdown>
                    <el-dropdown-menu class="notification-dropdown-menu">
                      <div class="head">
                        <ul>
                          <li>
                            <h4>
                              <span
                                ><img
                                  src="@/assets/images/icons/notification/sub-bell-icon.svg"
                                  alt="bell-icon"
                                  height="18px"
                                  width="18px" /></span
                              >Notifications
                            </h4>
                          </li>
                          <li v-if="notifications && notifications.length >= 1">
                            <span class="mark-all-read-btn" @click.stop="markAllAsRead">Mark all as read</span>
                          </li>
                        </ul>
                      </div>
                      <div
                        class="each-notification-block"
                        v-if="notifications && notifications.length >= 1"
                      >
                        <el-dropdown-item
                          v-for="(item, index) in notifications"
                          :key="index"
                        >
                          <div class="notification-item">
                            <h4>{{ item.title }}</h4>
                            <p>{{ item.content }}</p>
                            <div class="notification-footer">
                              <span class="notification-date">{{ moment(item.created_at).format('MMM D, YYYY h:mm A') }}</span>
                              <span
                                class="mark-read-btn"
                                @click.stop="handleCommand(item._id)"
                              >Mark as read</span>
                            </div>
                          </div>
                        </el-dropdown-item>
                      </div>
                      <div class="notification-no-data" v-else>
                        <img
                          src="@/assets/images/icons/notification/no-notifications.jpg"
                          alt="bell-icon"
                          height="40px"
                          width="40px"
                        />
                        <p class="notify-para">No New Notifications</p>
                      </div>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </el-badge>
            </div>
          </li>
          <li>
            <div class="avatar profile-dropdown">
              <el-dropdown
                popper-class="profile-dropdown-new"
                placement="bottom-start"
              >
                <el-button>
                  <UserAvatar
                    :size="35"
                    :src="snapUrl"
                    :first-name="getProfileData && getProfileData.first_name"
                    :last-name="getProfileData && getProfileData.last_name"
                  />
                </el-button>

                <template #dropdown>
                  <el-dropdown-menu class="login-profile" placement>
                    <div id="profile">
                      <div class="profile-pop">
                        <div class="dropdown-profile-img">
                          <UserAvatar
                            :size="100"
                            :src="snapUrl"
                            :first-name="getProfileData && getProfileData.first_name"
                            :last-name="getProfileData && getProfileData.last_name"
                          />
                        </div>

                        <div class="edit-icon">
                          <img
                            src="@/assets/images/icons/profile/edit-profile-pic.svg"
                            alt="edit-pic"
                          />
                        </div>
                        <el-dropdown-item class="profile-content">
                          <h3 v-if="getAuthenticatedUser" class="value">
                            {{ this.getProfileUserNameForHeader }}
                          </h3>
                          <p>
                            {{
                              userTypeMap[this.getProfileDesignationForHeader]
                            }}
                          </p>
                          <p v-if="currentLabName" class="profile-lab-name">
                            {{ currentLabName }}
                          </p>
                        </el-dropdown-item>
                        <div v-if="availableRoles.length > 1" class="role-switcher">
                          <el-select
                            v-model="selectedRole"
                            size="small"
                            popper-class="role-select-popper"
                            :popper-append-to-body="false"
                            :loading="switchingRole"
                            @change="switchRole"
                          >
                            <el-option
                              v-for="role in availableRoles"
                              :key="role"
                              :label="userTypeMap[role] || role"
                              :value="role"
                            />
                          </el-select>
                        </div>
                        <div class="username">
                          <el-button @click="viewProfile()">
                            <div>
                              <ul>
                                <li>
                                  <span
                                    ><img
                                      src="@/assets/images/icons/profile/user-profile.svg"
                                      alt="user-profile"
                                  /></span>
                                  <h4>View Profile</h4>
                                </li>
                              </ul>
                            </div>
                          </el-button>
                          <el-button @click="updatePassword()">
                            <ul>
                              <li>
                                <span
                                  ><img
                                    src="@/assets/images/icons/profile/password.svg"
                                    alt="right-arrow"
                                /></span>
                                <h4>Update Password</h4>
                              </li>
                            </ul>
                          </el-button>
                          <el-button @click="logOut()">
                            <ul>
                              <li>
                                <span
                                  ><img
                                    class="logout"
                                    src="@/assets/images/icons/profile/log-out.svg"
                                    alt="log-out"
                                /></span>
                                <h4>Log Out</h4>
                              </li>
                            </ul>
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </li>
          <!-- <li>
            <div class="notification-block">
              <el-dropdown>
                <el-button>
                  <img
                    src="../assets/images/icons/active.svg"
                    width="30"
                    height="30"
                  />
                </el-button>
                <template #dropdown>
                  <div id="notification">
                    <div class="head">
                      <ul>
                        <li>
                          <h4>
                            <span
                              ><img
                                src="@/assets/images/icons/notification/bell-icon.svg"
                                alt="bell-icon" /></span
                            >Notification
                          </h4>
                        </li>
                        <li>
                          <img
                            src="@/assets/images/icons/notification/cancel.svg"
                            alt="cancel.svg"
                          />
                        </li>
                      </ul>
                    </div>
                    <div class="notification-msg">
                      <ul>
                        <li>
                          <img
                            src="@/assets/images/icons/notification/notification-emoji.svg"
                            alt="notification-emoji"
                          />
                        </li>
                        <li>
                          <h4>Almost done!</h4>
                          <p>
                            Complete registration of<br />
                            your business profile to<br />start work.
                          </p>
                        </li>
                        <li>
                          <img
                            src="@/assets/images/icons/notification/msg-cancel.svg"
                            alt="cancel.svg"
                          />
                        </li>
                      </ul>
                    </div>
                    <div class="notification-msg">
                      <ul>
                        <li>
                          <img
                            src="@/assets/images/icons/notification/notification-emoji.svg"
                            alt="notification-emoji"
                          />
                        </li>
                        <li>
                          <h4>Almost done!</h4>
                          <p>
                            Complete registration of<br />
                            your business profile to<br />start work.
                          </p>
                        </li>
                        <li>
                          <img
                            src="@/assets/images/icons/notification/msg-cancel.svg"
                            alt="cancel.svg"
                          />
                        </li>
                      </ul>
                    </div>
                    <div class="notification-msg">
                      <ul>
                        <li>
                          <img
                            src="@/assets/images/icons/notification/notification-emoji.svg"
                            alt="notification-emoji"
                          />
                        </li>
                        <li>
                          <h4>Almost done!</h4>
                          <p>
                            Complete registration of<br />
                            your business profile to<br />start work.
                          </p>
                        </li>
                        <li>
                          <img
                            src="@/assets/images/icons/notification/msg-cancel.svg"
                            alt="cancel.svg"
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </template>
              </el-dropdown>
            </div>
          </li> -->
        </ul>
      </el-col>
    </el-row>
    <!-- Mega Dropdown UI -->
    <div id="navigation-toggle">
      <el-drawer v-model="menuNavigation" size="100%" direction="ttb">
        <span>
          <div class="menu-inner-view">
            <el-row>
              <el-col :span="8">
                <ul class="navbar-logo-grid">
                  <li>
                    <div class="logo">
                      <img
src="@/assets/images/labSquire-logo.svg"
                        alt="testgo-tri-logo"
                        style="height: 60px;"
                        class="img-fluid"
                      />
                    </div>
                  </li>
                  <li class="pl-20">
                    <div class="menu-toggle-button cursor">
                      <span
                        class="el-dropdown-link"
                        @click="menuNavigation = false"
                      >
                        <img
                          src="../assets/images/dashboard-icon.svg"
                          alt="dashboard-icon"
                        />
                      </span>
                    </div>
                  </li>
                  <li>
                    <div class="menu-title">
                      <h3 class="name">Menu</h3>
                    </div>
                  </li>
                </ul>
              </el-col>
              <el-col :span="13" class="menu-search"> </el-col>
              <el-col :span="3" class="drawer-close-button">
                <el-button
                  size="medium"
                  class="el-white"
                  type="info"
                  plain
                  @click="menuNavigation = false"
                >
                  <img
                    src="@/assets/images/icons/cases/close-btn.svg"
                    alt="icon"
                    width="30"
                /></el-button>
              </el-col>
            </el-row></div
        ></span>
        <NavigationMenu></NavigationMenu>
      </el-drawer>
    </div>
  </section>
</template>

<script>
import NavigationMenu from "@/components/NavigationMenu";
import navFilters from "@/components/navbarFilter/index.vue";
import Title from "@/components/navbar/Title";
import GoBackButton from "@/components/navbar/GoBack";
import KeyboardShortcuts from "@/components/navbar/KeyboardShortcuts";
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import GlobalHelper from "@/mixins/GlobalHelper";
import userConstants from "@/config/constants/userConstants";
import $axios from "@/config/axios";
import moment from "moment-timezone";
export default {
  name: "topbar-default",
  components: {
    NavigationMenu,
    navFilters,
    Title,
    GoBackButton,
    KeyboardShortcuts,
  },
  mixins: [UserPermissionsHelper, GlobalHelper],
  data() {
    return {
      scrollPosition: null,
      menuNavigation: false,
      snapUrl: "",
      globalRouteNames: ["GlobalSearch"],
      casesRouteNames: [
        "AllCases",
        "ActiveCases",
        "SamplesReceived",
        "PendingCases",
        "CompleteCases",
        "ArchiveCase",
        "AllOrders",
        "ActiveOrders",
        "CompleteOrders",
        "ArchiveOrders",
        "RejectionOrders",
        "PendingOrders",
        "PartialOrders",
        "AllBillingCase",
        "ActiveBillingCase",
        "PendingBillingCase",
        "CompleteBillingCase",
        "allResults",
        "ActiveResults",
        "ToStartResults",
        "CompleteResults",
        "ArchiveResults",
        "ProcessingResults",
        "FailedResults",
        "AllPhysicians",
        "ActivePhysicians",
        "InActivePhysicians",
        "AllHospitals",
        "ActiveHospitals",
        "InActiveHospitals",
        "QCChatResults",
        "ToStartQCChartResults",
        "CompleteQCChartResults",
        "icd10codes",
        "allSendOuts",
        "allReceivedSendOuts",
        "ActiveReceivedSendOuts",
        "CompleteReceivedSendOuts",
        "LabInformation",
        "userAccounts",
        "ActiveUserAccounts",
        "InActiveUserAccounts",
        "LabDocumentFolders",
        "casesLogs",
        "ordersLogs",
        "archive",
        "AllApprovalPendingCases",
        "ActiveApprovalPendingCases",
        "PendingApprovalPendingCases",
        "CompleteApprovalPendingCases",
        "RejectedApprovalPendingCases",
        "QCChartReport",
        "AllLabListing",
        "EmailLogs",
        "TsiReports",
        "ActiveSendOuts",
        "CompleteSendOuts",
        "AllInstrumentTestConfig",
        "BloodQCLevel",
        "BloodQCchart",
        "ArchiveDataCases",
        "ArchiveDataOrders",
        "bloodResult",
        "allBulkAccession",
        "LabdaqPendingOrders",
        "LabdaqPendingResults",
        "ValidationCases",
        "ValidationOrders",
        "ActiveValidationCases",
        "PendingValidationCases",
        "CompleteValidationCases",
        "ArchiveValidationCases",
        "ActiveValidations",
        "CompleteValidations",
        "ArchiveValidations",
        "AllPendingBilledCases",
        "BilledCases",
        "ClientBilledCases",
        "ExceptionBilledCases",
        "OnholdBilledCases",
        "BilledExceptionBilledCases",
        "BilledPatientBilledCases",
        "LabdaqInvalidOrders",
        "LabdaqCompletedOrders",
        "CodingCases",
        "AllProfiles",
        "AllMarketersData",
        "MarketerData",
        "RevenueStats",
        "FileUpload",
        "AllRevenueStats",
        "IndividualRevenueStats",
        "NewReportCases",
        "AllPhlebioOrders",
        "EMRNotSend",
        "UaQcResults",
        "CriticalCases",
        "PartialOrders",
        "ExceptionResolvedCases",
        "ArchiveSendouts",
        "AutoSendoutFailed",
        "AllPhlebioRequests",
        "ReleasePending",
        "ClinicalChemistryConfig",
        "ExceptionReviewedCases",
        "RejectedCases",
        "ReplacedInsurance",
        "EMROrdersWithIssues",
        "PhlebioEMROrders",
        "RequiresAttentionCases",
        "RequiresAttentionOrders",
        "FaxNotSentCases",
        "FaxInProcessCases",
        "TatCrossedCases",
        "SampleAckOrders",
        "PartiallyRejectedOrders",
        "InsuranceOnHoldOrders",
        "CrossLabRegisteredCases",
        "PriorityCases",
        "AddOnTestsOrders",
        "InsuranceExceptionCases",
        "InstrumentQueue",
      ],
      userTypeMap: userConstants.USER_TYPE_MAP,
      selectedLab: "",
      selectedRole: "",
      switchingRole: false,
      orderRouteNames: [
        "AllOrders",
        "ActiveOrders",
        "CompleteOrders",
        "ArchiveOrders",
        "Order-Information",
        "Edit-Order-Info",
        "RejectionOrders",
        "PendingOrders",
        "PartialOrders",
      ],
      moment,
      total: 0,
      notifications: [],
      countsLoading: false,
    };
  },

  computed: {
    // Pages opened for one record carry its id in the URL (/cases/:case_id, ...).
    isDetailRoute() {
      return Object.keys(this.$route.params || {}).length > 0;
    },
    ...mapGetters("auth", [
      "getAuthenticatedUser",
      "getUserPrimaryLabId",
      "getUserAllowedLabs",
      "getAuthenticationDetails"
    ]),
    ...mapGetters("profile", [
      "getProfileData",
      "getProfileUserNameForHeader",
      "getProfileDesignationForHeader",
    ]),
    isRouteActive() {
      return (routeNames) =>
        routeNames.indexOf(this.$route.name) != -1 ? true : false;
    },
    availableRoles() {
      const user = this.getAuthenticatedUser || {};
      return Array.from(new Set(user.roles || [user.user_type].filter(Boolean)));
    },
    currentLabName() {
      const lab = (this.getUserAllowedLabs || []).find(
        (item) => item._id === this.getUserPrimaryLabId
      );
      return lab ? lab.name : "";
    },
  },
  async mounted() {
    await this.$store.dispatch("profile/getProfile");
    if (this.getProfileData && this.getProfileData.avatar) {
      this.snapUrl = this.getProfileData.avatar;
    }
    // Scroll
    window.addEventListener("scroll", this.updateScroll);
    this.toggleBodyClass("removeClass", "navbarTypeTwo");
    if (this.getUserPrimaryLabId) {
      this.selectedLab = this.getUserPrimaryLabId;
    }
    this.selectedRole = this.getAuthenticatedUser?.activeRole || this.getAuthenticatedUser?.user_type || "";
    this.fetchNotifications();
  },
  watch: {
    $route() {
      this.menuNavigation = false;
    },
  },
  methods: {
    gotoInventory() {
    let url = `${process.env.VUE_APP_STORE_MODULE}?token=${this.getAuthenticationDetails?.access_token}`;
    window.open(url, "_blank");
    },
    setSelectedLab() {
      let selectedLabDetails = this.getUserAllowedLabs.find(
        (lab) => lab._id == this.selectedLab
      );
      this.$store.dispatch("auth/setPrimaryLabDetails", selectedLabDetails);
      window.location.reload();
    },
    async switchRole(role) {
      if (!role || this.switchingRole) return;
      this.switchingRole = true;
      const currentRoute = this.$route;
      try {
        await this.$store.dispatch("auth/switchRole", role);
        await this.$router.replace({
          path: currentRoute.path,
          query: { ...currentRoute.query, role },
          hash: currentRoute.hash,
        });
        window.location.reload();
      } catch (error) {
        console.error("Role switch failed:", error);
        this.selectedRole = this.getAuthenticatedUser?.activeRole || this.getAuthenticatedUser?.user_type || "";
      } finally {
        this.switchingRole = false;
      }
    },
    addNewOrder() {
      this.$router.push({
        path: "/new-order",
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    async logOut() {
      await this.$store.dispatch("globalReset");
      this.$router.push("/signin");
    },
    // Scroll
    async updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    updatePassword() {
      this.$router.push("/update-password");
    },
    viewProfile() {
      this.$router.push("/user-profile");
    },
    goToGlobalReports() {
      this.$router.push("/global-search");
    },
    goToNewCase() {
      this.$router.push({
        name: "NewCase",
        query: { ...this.$route.query, redirectRoute: this.$route.name },
        params: { title: "New Case" },
      });
    },
    goToNewOrders() {
      this.$router.push({
        name: "newOrder",
      });
    },
    async toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    async fetchNotifications() {
      this.countsLoading = true;
      try {
        const { data } = await $axios.get("/go-live");
        if (data.success) {
          this.notifications = data.data;
          this.total = data.count;
        }
      } catch (e) {
        // silently fail — badge stays at previous value
      } finally {
        this.countsLoading = false;
      }
    },
    async handleCommand(id) {
      try {
        await $axios.post(`/go-live/${id}/read`);
        await this.fetchNotifications();
      } catch (e) {
        // silently fail
      }
    },
    async markAllAsRead() {
      try {
        await Promise.all(
          this.notifications.map((n) => $axios.post(`/go-live/${n._id}/read`))
        );
        await this.fetchNotifications();
      } catch (e) {
        // silently fail
      }
    },
  },
};
</script>

<style lang="scss">
.default-navbar {
  padding: 5px 30px 7px 30px;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  .navbar-logo-grid {
    display: flex;
    align-items: center;
    li {
      &:not(:last-child) {
        margin-right: 15px;
      }
      .logo {
        img {
          width: 150px;
          margin-top: 5px;
        }
      }
      .menu-toggle-button {
        margin-bottom: -5px;
        .el-dropdown-menu {
          padding: 0;
        }
      }
      .nav-title {
        h3 {
          color: #363636;
          font-size: 1em;
          font-weight: 600;
          white-space: nowrap;
          @media (min-width: 1200px) and (max-width: 1700px) {
            font-size: 0.88em !important;
          }
        }
      }
    }
    .menu-title {
      color: #273480;
      text-transform: uppercase;
      h3 {
        font-size: 1rem;
        font-weight: 600;
      }
    }
  }

  .navbar-action-grid {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    li {
      &:not(:last-child) {
        margin-right: 15px;
      }
      .new-case-button {
        button {
          min-height: 30px;
          padding: 8px 10px;
          color: #273480;
          font-weight: 500;
          background: rgba(199, 208, 248, 0.4);
          border: none;
          border-radius: 5px;

          span {
            &:nth-child(1) {
              display: flex;
              align-items: center;
              img {
                width: 15px;
              }
            }
          }
          .plus-icon {
            margin-right: 7px;
          }
        }
      }
      .scan-qr-button {
        button {
          min-height: 30px;
          padding: 5px 15px;
          color: #ffffff;
          font-weight: 400;
          background: linear-gradient(90deg, #273480 0%, #BF1B39 100%);
          border: none;
          border-radius: 6.34px;
        }
      }
      .global-search {
        min-height: 32px;
        height: 32px;
        padding: 5px 10px;
        background: #BF1B39;
        font-weight: 500;
        color: #ffffff;
        border: none;
        text-transform: uppercase;
        border-radius: 6.4px;
        transition: all 0.2s ease-in-out;
        .global-search-d-flex {
          display: flex;
          align-items: center;
        }
        img {
          width: 14px;
        }

        .inactive {
          display: block;
          transition: all 2s ease-in-out;
        }
        &:hover {
          color: #ffff;
          background: #273480;
          transition: all 0.2s ease-in-out;
        }
      }
      .profile-dropdown,
      .notification-block {
        margin-bottom: -8px;
        .el-button {
          min-height: auto;
          padding: 0;
          background: none;
          border: none;
          .el-avatar {
            width: 32px !important;
            height: 32px !important;
            margin-bottom: 1px;
            border-radius: 50%;
            img {
              width: 100%;

              object-fit: cover;
            }
          }
        }
      }
    }
  }
}
.quick-navigation {
  z-index: 999;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  @media (min-width: 1200px) and (max-width: 1500px) {
    justify-content: center;
    padding: 0 10px;
  }
  a {
    display: block;
    padding: 5px;
    color: #888383;
    font-size: 14.5px;
    font-weight: 500;
    transition: all 0.2s ease-in-out;
    @media (min-width: 1200px) and (max-width: 1700px) {
      padding: 5px;
      font-size: 0.9em !important;
      font-size: 13px;
    }
    &:not(:last-child) {
      margin-right: 25px;
      @media (min-width: 1200px) and (max-width: 1700px) {
        margin-right: 15px;
      }
    }
    &:hover {
      color: #273480;
    }
  }
  .global-search-d-flex {
    display: flex;
    align-items: center;
  }
  img {
    width: 12px;
    position: relative;
    top: 2px;
  }
}
#top-navbar-view {
  box-sizing: border-box;
  .quick-navigation {
    padding-bottom: 12px;
    ul {
      display: flex;
      align-items: center;
      overflow-x: auto;
      justify-content: center;
      li {
        &:not(:last-child) {
          margin-right: 15px;
          @media (min-width: 1200px) and (max-width: 1440px) {
            margin-right: 10px;
          }
        }
        a {
          font-size: 12px !important;
          text-transform: uppercase;
          color: #000;
          font-weight: 500;
          background: #eef2f5;
          padding: 2px 15px;
          border-radius: 30px;
          border: 1px solid rgb(209 219 227);
          white-space: nowrap;
          @media (min-width: 1200px) and (max-width: 1440px) {
            padding: 2px 8px;
          }
          &.bg-blue {
            color: #ffff;
            background: #273480;
          }
          &.router-link-active {
            background: #BF1B39;
            color: #fff;
            /* box-shadow: 0 0 1px 1px #BF1B39; */
          }
          &.active {
            background: #BF1B39;
            color: #fff;
            /* box-shadow: 0 0 1px 1px #BF1B39; */
          }
          @media (min-width: 1200px) and (max-width: 1500px) {
            padding: 2px 7px;
          }
        }
      }
    }
  }

  .top-navbar-view-inner {
    .left-nav {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .logo {
        img {
          width: 150px;
        }
      }
      menu {
        position: relative;
        top: 3px;
      }
    }
    .center-nav {
      .nav-center-block {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 45px;
        max-height: 100%;
        padding: 0 10px;
        h3 {
          color: #0a5da6;
          font-size: 16px;
          font-weight: 900;
        }
      }
    }
    .right-nav {
      display: flex;
      justify-content: flex-end;

      .block {
        position: relative;
        top: 11px;
        margin: 0 1.5em 0 0.5em;
      }
      .avatar {
        .el-button {
          padding: 0;
          border: none;
          &:hover {
            background-color: transparent;
          }
        }
      }
    }
  }
}
#navigation-toggle {
  .el-drawer__body {
    padding: 0;
  }
  @mixin search-bar {
    height: 38px;
    border-radius: 20px;
  }
  .menu-inner-view {
    padding: 5px 30px 7px 30px;
    background: #fff;
    border-bottom: 1px solid #e0e0e0;
    .menu-logo {
      display: flex;
      justify-content: space-around;
      .logo {
        padding: 0 2rem;
      }
    }
    .menu-search {
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
      h2 {
        padding: 9px 14px;
        color: #0a5da6;
        font-size: 16px;
        font-weight: 600;
      }
    }
  }
  .form-group {
    display: flex;
    width: 25%;

    span {
      position: relative;
      top: 5px;
      right: 32px;
      width: 30px;
      border-radius: 50%;
    }

    .el-input--suffix .el-input__inner {
      @include search-bar;
    }
  }
  .el-drawer__header {
    display: none;
  }
  .drawer-close-button {
    padding: 0 10px;
    text-align: end;
    display: flex;
    justify-content: flex-end;
    .el-button {
      padding: 0;
      border: none;
      &:active:hover {
        background: transparent;
      }
    }
  }
}

// profile
.profile-dropdown-new {
  z-index: 2129;
}
.login-profile {
  border: 1px solid #e5e7eb !important;
  border-radius: 16px;
  box-shadow: 0 10px 28px rgba(31, 41, 55, 0.14);
}
#profile {
  padding-top: 5px;
  .profile-pop {
    width: 360px;
    max-width: calc(100vw - 32px);
    height: 100%;
    padding: 5px 10px;
    text-align: center;
    background-color: white;
    border: none;
    border-radius: 10px;
    .profile-image {
      img {
        width: 90px;
        height: 100px;
      }
    }

    .edit-icon {
      img {
        position: relative;
        top: -14px;
        left: 1px;
        width: 21px;
        height: 18px;
      }
    }
    .profile-content {
      display: block;
      margin-top: -13px;
      line-height: 20px;
      &:hover {
        background-color: #fff;
      }
      h3 {
        color: #4f4f4f;
        font-size: 17px;
        font-weight: 500;
      }
      p {
        color: #828282;
        font-size: 14px;
        font-weight: 500;
      }
      .profile-lab-name {
        margin-top: 4px;
        color: #536273;
        font-size: 13px;
        font-weight: 600;
      }
    }
    .role-switcher {
      margin: 18px 14px 18px;
      padding: 16px 14px;
      text-align: left;
      background: #f8fafc;
      border: 1px solid #e5e7eb;
      border-radius: 10px;
      .el-select {
        width: 100%;
      }
      .el-input__wrapper {
        min-height: 48px;
        border: 1px solid #cbd5e1;
        border-radius: 8px;
        box-shadow: none;
      }
      &::before {
        display: block;
        margin-bottom: 10px;
        color: #6b7280;
        content: "ACTIVE ROLE";
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0.04em;
      }
    }
    .username {
      padding: 0 5px;
      .el-button {
        width: 100%;
        min-height: 30px;
        padding: 8px 10px;
        margin: 0;
        border: none;
        &:hover,
        &:focus {
          background-color: white;
        }
      }
      ul {
        display: flex;
        justify-content: space-between;
        align-items: center;
        li {
          display: flex;
          align-items: center;
          h4 {
            margin-left: 12px;
            color: #4f4f4f;
            font-size: 14px;
          }
        }
      }
      .log-out {
        margin-left: 1px;
      }
    }
    .password {
      .el-button {
        min-height: 30px;
        :hover {
          background-color: white;
        }
        li {
          display: flex;
          align-items: center;
          padding: 0;
          margin: 5px;
        }
        .log-out {
          padding-right: 68px;
        }
        h4 {
          color: #4f4f4f;
          font-size: 14px;

          .log-out {
            padding-left: 20px;
          }

          img {
            margin: 0 9px -4px -1px;
          }
        }
      }
    }
  }
  .dropdown-profile-img {
    .el-avatar > img {
      width: 100% !important;

      object-fit: cover;
    }
  }
}

.location_grid {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .el-select {
    height: 30px;
    margin: 0px 0px 10px;
    .el-input__inner {
      height: 30px;
      box-shadow: none;
      padding-left: 10px;
      font-weight: 500;
      color: #000;
      font-size: 11px !important;
      background: #fff;
      padding: 2px 10px;
      border-radius: 10px;
      border: 0.640567px solid #2d9cdb;
      white-space: nowrap;
    }
    .select-trigger {
      width: 175px;
    }

    .el-input__suffix {
      background: transparent;
      border-radius: 0 5px 5px 0;
      right: 3px;
      top: 1px;
      height: 98%;

      .el-icon {
        color: #000 !important;
        font-weight: 800;
      }
    }
  }
}
// notification//
.notification-block {
  .el-badge__content.is-fixed {
    position: absolute;
    right: 24px;
    top: 8px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #273480;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    height: 20px;
    border-radius: 50%;
    padding: 0;
  }
  .el-button {
    margin: 0 6px;
    border: none;
    padding: 0;
    &:hover,
    &:focus {
      background-color: white;
      border: #e5e5e5;
    }
  }
  .el-dropdown-menu__item {
    background-color: red;
  }
}
.head {
  ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 14px;
    background-color: #c7d0f826;
    li {
      h4 {
        font-size: 14px;
        img {
          margin-right: 10px;
          margin-bottom: -3px;
        }
        p {
          line-height: 17px;
        }
      }
      .mark-all-read-btn {
        font-size: 11px;
        color: #273480;
        cursor: pointer;
        font-weight: 600;
        text-decoration: underline;
        white-space: nowrap;
        &:hover {
          color: #56ccf2;
        }
      }
    }
  }
}
.each-notification-block {
  max-height: 200px;
  min-width: 250px;
  max-width: 300px;
  overflow: auto;
  padding-bottom: 5px;
}

.notification-dropdown-menu {
  padding: 1px !important;
  border: none !important;

  .el-dropdown-menu__item {
    color: #000;
    margin: 5px;
    border-radius: 7px;
    font-weight: 500 !important;
    background: #ffffff;
    border: 0.5px solid rgba(86, 204, 242, 0.8);
    height: auto;
    transition: 0.5s;
    padding: 0;
    display: block;
    .notification-item {
      padding: 8px 15px 8px 20px;
      position: relative;
      &::before {
        content: "•";
        position: absolute;
        color: #273480;
        left: 1px;
        top: 4px;
        font-size: 30px;
        line-height: 1;
      }
      h4 {
        font-size: 12px;
        line-height: 16px;
        margin: 0 0 3px 0;
      }
      p {
        font-size: 11px;
        color: #555;
        line-height: 15px;
        margin: 0 0 6px 0;
        white-space: normal;
        word-break: break-word;
      }
      .notification-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 4px;
        .notification-date {
          font-size: 10px;
          color: #999;
        }
        .mark-read-btn {
          font-size: 10px;
          color: #273480;
          cursor: pointer;
          font-weight: 600;
          text-decoration: underline;
          &:hover {
            color: #56ccf2;
          }
        }
      }
    }
    &.is-disabled {
      padding: 0 15px !important;
      line-height: 32px;
    }
  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    color: #000 !important;
    font-weight: 500 !important;
    background: #eef2f5 !important;
    transition: 0.5s;
  }
}

.block {
  .el-popper__arrow::before {
    box-sizing: none;
    width: 0;
    height: 0;
  }
}
.value {
  text-transform: capitalize;
}
.notification-no-data {
  text-align: center;
  img {
    width: 125px;
    height: 125px;
  }
  .notify-para {
    color: #273480;
    font-weight: 500;
    padding: 10px 0;
    font-size: 16px;
  }
}
</style>
